import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdPerson, MdWhatsapp } from "react-icons/md";

export default function OneClient({ data }) {
  const appContext = useContext(AppContext);

  /* Place states here */


  function view() {
    appContext.navTo({
      item: "side-view",
      subItem: "non-stock-item",
      extraItem: data.uuid,
    });
  }

  return (
    <div
      className="mShadow1"
      onClick={view}
      style={{
        padding: "10px",
        paddingTop: "20px",
        paddingBottom: "20px",
        borderBottom: "0px solid var(--secondaryColor)",
        cursor: "pointer",
      }}
    >
      <h6
        style={{
          fontSize: "22px",
          flexShrink: 0,
        }}
        className="font-light mNoMargin"
      >
        
        {data.title}
      </h6>

      <h6
        style={{
          fontSize: "16px",
          flexShrink: 0,
        }}
        className="font-bold mNoMargin"
      >
        
        {formatMoney(data.unitPrice)} TZS
      </h6>

      <h6
        style={{
          fontSize: "14px",
        }}
        className="font-semi-bold text-end text-muted"
      >
        {data.unit}
      </h6>

      
    </div>
  );
}
